import { Box, Typography, useTheme } from "@mui/material"
import { Carousel, CarouselItem } from "components/Carousel"

import { useState } from "react"
import AttractionModal from "./AttractionModal"
import { useTranslation } from "providers/i18n"
import { ATTRACTION_TYPE } from "extensions/iconsiam/constants"
import { usePost } from "hooks/post/usePost"
import { LeftToRightWrapper } from "components/LeftToRightWrapper"

const AttractionButton = () => {
  const { t } = useTranslation()
  const { hasData, postData: attractions } = usePost(ATTRACTION_TYPE)
  const theme = useTheme()
  const { root, carousel, carouselItem, image, attractionText } =
    theme.components?.[`AttractionButton`].styleOverrides || {}

  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
  }

  const handleCloseModal = () => {
    setOpen(false)
  }

  return (
    <>
      {hasData && (
        <LeftToRightWrapper>
          <Box sx={root} onClick={handleClick}>
            <Carousel
              options={{
                type: "fade",
                rewind: true,
                autoplay: true,
                pagination: false,
                interval: 3000,
                arrows: false,
                speed: 1500,
                padding: 10,
              }}
              sx={carousel}
            >
              {attractions.map((attraction) => {
                return (
                  <CarouselItem key={attraction.id} sx={carouselItem}>
                    <Box
                      sx={image}
                      component="img"
                      src={attraction?.properties?.feature_image}
                    />
                  </CarouselItem>
                )
              })}
            </Carousel>
            <Typography sx={attractionText}>{t("Attractions")}</Typography>
          </Box>
        </LeftToRightWrapper>
      )}
      <AttractionModal
        data={attractions}
        open={open}
        onClose={handleCloseModal}
      />
    </>
  )
}
export default AttractionButton
